/**
 * "Show strategies optimised for" — the goal chips every analyser carries, in the owner's order
 * (Best estate first and the default; see engineGoalCards.ts). Presentation only: the engine is
 * never re-run by a chip. Lifted from the aged care and village pages so the downsizer and granny
 * flat analysers read as the same product.
 */
import React from 'react';
import { GOAL_FOCUS_CHIPS, goalFocusExplanation, type GoalFocus } from '../../strategy/engineGoalCards.ts';

interface GoalChipRowProps {
    value: GoalFocus;
    onChange: (focus: GoalFocus) => void;
    /** "staying put", "not downsizing" — named in the line under the chips. */
    baselineWord: string;
}

const GoalChipRow = ({ value, onChange, baselineWord }: GoalChipRowProps) => (
    <div className="mb-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <p className="text-sm font-semibold text-slate-800 mb-3">Show strategies optimised for</p>
        <div className="flex flex-wrap gap-2">
            {GOAL_FOCUS_CHIPS.map(({ id, label }) => (
                <button
                    key={id}
                    type="button"
                    onClick={() => onChange(id)}
                    className={`flex-1 min-w-[140px] rounded-lg px-4 py-2.5 text-sm font-semibold transition-all border-2 ${
                        value === id
                            ? 'border-blue-600 bg-blue-50 text-blue-900 shadow-sm'
                            : 'border-slate-200 bg-slate-50 text-slate-700 hover:border-slate-300 hover:bg-white'
                    }`}
                >
                    {label}
                </button>
            ))}
        </div>
        <p className="text-xs text-slate-600 mt-3">{goalFocusExplanation(value, baselineWord)}</p>
    </div>
);

export default GoalChipRow;
